import { FormField, Select } from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';
import { fetchSubscribedGroups } from '../../api-auth/bot-accounts/apis';
import { DDF_REGIONS } from '../../lib/constants';

// Select has no deselect, so this entry is how the lab opts out of a default device group
export const NONE_OPTION = { label: 'None', value: '' };

/**
 * Default device group dropdown for lab onboard/configure. Options are the requester's subscribed
 * groups grouped by region (same source as bot account configure). Each option carries
 * { label: name, value: id, description: id, region } so callers read id/region straight off selectedOption.
 */
export default function DefaultGroupSelect({ selectedOption, onChange, onStatusChange }) {
    const [options, setOptions] = useState([]);
    const [status, setStatus] = useState('pending');

    const updateStatus = (value) => {
        setStatus(value);
        onStatusChange(value);
    };

    useEffect(() => {
        (async function () {
            updateStatus('loading');
            try {
                const result = [NONE_OPTION];
                for (const region of DDF_REGIONS) {
                    const response = await fetchSubscribedGroups(region.regionName);
                    result.push({
                        label: region.regionName,
                        options: (response['response'] || [])
                            .filter((group) => group.privilege !== 'root')
                            .map((group) => ({
                                label: group.name,
                                value: group.id,
                                description: group.id,
                                region: region.regionName,
                            })),
                    });
                }
                setOptions(result);
                updateStatus('finished');
            } catch (e) {
                console.error('Fail to load subscribed groups', e);
                updateStatus('error');
            }
        })();
    }, []);

    return (
        <FormField
            label={
                <span>
                    Default device group <i>- optional</i>{' '}
                </span>
            }
            description="Devices in the lab will be automatically moved from Common into this group after registration"
        >
            <Select
                selectedOption={selectedOption}
                options={options}
                statusType={status}
                loadingText="Loading groups"
                errorText="Error fetching groups"
                empty="No group found"
                filteringType="auto"
                expandToViewport
                placeholder="Select default device group"
                onChange={({ detail }) => onChange(detail.selectedOption)}
            />
        </FormField>
    );
}
